var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.705 5.71944C20.0983 5.32609 20.0983 4.68835 19.705 4.295C19.3116 3.90165 18.6739 3.90165 18.2806 4.295L12 10.5755L5.71945 4.295C5.3261 3.90165 4.68836 3.90165 4.29501 4.295C3.90166 4.68835 3.90166 5.32609 4.29501 5.71944L10.5756 12L4.29501 18.2805C3.90166 18.6739 3.90166 19.3116 4.29501 19.705C4.68836 20.0983 5.3261 20.0983 5.71945 19.705L12 13.4244L18.2806 19.705C18.6739 20.0983 19.3116 20.0983 19.705 19.705C20.0983 19.3116 20.0983 18.6739 19.705 18.2805L13.4244 12L19.705 5.71944Z",
    fill: "#101D3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.81bbc9309370426ebe4e24211fa4071f.svg";
export { ForwardRef as ReactComponent };